import { useEffect, useState } from 'react';

export const useTonPrice = () => {
    const [rates, setRates] = useState({ usd: null, krw: null });
    useEffect(() => {
        let alive = true;
        fetch('/api/ton-price')
            .then((r) => (r.ok ? r.json() : null))
            .then((data) => {
                if (!alive || !data) return;
                const usd = typeof data.usd === 'number' && data.usd > 0 ? data.usd : null;
                const krw = typeof data.krw === 'number' && data.krw > 0 ? data.krw : null;
                setRates({ usd, krw });
            })
            .catch(() => {});
        return () => {
            alive = false;
        };
    }, []);
    return rates;
};

export const formatUsd = (tonAmount, tonUsd) => {
    if (!tonUsd) return '';
    const n = Number(tonAmount);
    if (!Number.isFinite(n) || n <= 0) return '';
    const total = n * tonUsd;
    if (total < 1) return `≈ $${total.toFixed(2)}`;
    return `≈ $${total.toFixed(2).replace(/\.00$/, '')}`;
};

export const formatKrw = (tonAmount, tonKrw) => {
    if (!tonKrw) return '';
    const n = Number(tonAmount);
    if (!Number.isFinite(n) || n <= 0) return '';
    const total = n * tonKrw;
    return `≈ ₩${Math.round(total).toLocaleString('en-US')}`;
};
